import _ from 'lodash';
import { EVENT_TYPES, EVENT_TYPES_HISTORY } from '~/utils/constants';
import Comment from './events/comment/Comment.vue';
import CampaignHistory from './events/campaign-history/CampaignHistory.vue';
import CreativeHistory from './events/creative-history/CreativeHistory.vue';
import CreativePreview from './events/creative-preview/CreativePreview.vue';
import SmsLog from './events/sms-log/SmsLog.vue';
import EmailLog from './events/email-log/EmailLog.vue';

export default {
  components: {
    Comment,
    CampaignHistory,
    CreativeHistory,
    CreativePreview,
    SmsLog,
    EmailLog,
  },
  props: {
    items: Array,
    filterEvents: {
      type: Function,
      default: event => {
        // TODO: in future we should probably add permissions for history events?
        if (event.type === EVENT_TYPES.HISTORY
            && event.data.type === EVENT_TYPES_HISTORY.OPERATOR_CHANGE) {
          return false;
        }

        if (event.type === EVENT_TYPES.HISTORY
            && event.data.type === EVENT_TYPES_HISTORY.CAMPAIGN_CHANGE
            && event.data.info.from === null
        ) {
          return false;
        }

        if (
          event.type === EVENT_TYPES.COMMENT
          && event.data.type === 'brief'
          && event.data.text === null
        ) {
          return false;
        }

        return true;
      },
    },
  },
  data() {
    return {
      EVENT_TYPES,
    };
  },
  computed: {
    timeline() {
      return _.cloneDeep(_.get(this, 'items', []))
        .filter(this.filterEvents)
        .map(event => {
          if (_.has(event, 'data.info.from') && event.data.info.from === null) {
            event.data.info.from = 'none';
            event.data.type = `${event.data.type}_NONE`;
          }
          return event;
        });
    },
  },
};



// WEBPACK FOOTER //
// ./src/gotu-vue-common/src/components/timeline/Timeline.js